export default __webpack_public_path__ + "static/media/image-41-min.2ef391b4.jpg";